<script setup lang="ts">
type Props = {
  name: string
  items: {
    label: string
    value: string
  }[]
  modelValue: string[]
  rules?: string
}

const props = withDefaults(
  defineProps<Props>(), { rules: '' },
)

const emit = defineEmits<{ (e: 'update:modelValue', value: string[]): void }>()

const innerValue = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
})
</script>

<template>
  <ValidationField
    v-slot:default="{ errors, handleChange }"
    v-model="innerValue"
    class="c-validationCheckBox"
    v-bind:name="name"
    v-bind:rules="rules"
  >
    <div
      class="c-validationCheckBox_controls"
    >
      <v-checkbox
        v-for="item in items"
        v-bind:key="item.label"
        v-model="innerValue"
        v-bind:label="item.label"
        v-bind:value="item.value"
        hide-details
        v-on:update:model-value="(v) => handleChange(v, errors.length > 0)"
      />
    </div>
    <div
      class="c-validationCheckBox_detail"
    >
      <div
        v-if="errors[0]"
        class="c-validationCheckBox_detail_error"
      >
        選択が必須となります
      </div>
    </div>
  </ValidationField>
</template>

<style lang="scss" scoped>
.c-validationCheckBox {
  display: block;
  margin-bottom: 30px;

  &:deep(.v-input) {
    margin-top: 0 !important;
    margin-right: 20px !important;
    margin-bottom: 10px !important;
  }

  &_controls {
    display: flex;
    flex-wrap: wrap;
  }

  &_detail {
    height: 12px;

    &_error {
      color: #dd2c00 !important;
      font-size: 12px;
      caret-color: #dd2c00 !important;
    }
  }
}
</style>
